import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import { Observable } from 'rxjs/Observable';

import { StorageService } from 'app/shared/services/storage.service';
import { SecurityService } from 'app/shared/services/security.service';
import { AppConfig } from 'app/app.config';
import { IResult } from 'app/shared/models/result.model';
import { IDtoEvent } from 'app/shared/models/incident/dto-event.model';
import { ModalIncidentComponent } from 'app/views/modales/incident/modal.incident.component';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { IncidentService } from '../../incident.service';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoJobCandidateBasic } from 'app/shared/models/employee/dto-jobcandidate-basic.model';
import { EmployeeService } from '../../employee.service';
import { EmailService } from '../../email.service';
import { IDtoEmail } from 'app/shared/models/dto-email.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { IDtoTicket } from 'app/shared/models/incident/dto-ticket.model';
import { ValidatorService } from 'app/shared/services/validator.service';
import { IDtoMessageDetail } from 'app/shared/models/dto-message-detail.model';
import { MessageService } from '../../message.service';

@Component({
  selector: 'incident',
  templateUrl: './incident.detail.template.html',
  styleUrls: ['./incident.detail.style.scss'],
})

export class IncidentDetailComponent implements OnInit {
  private currentItemName: string = 'inbox';
  private titleGroupTool: string = 'Sin';
  private titleTool: string = 'Solicitudes';
  private toolSubtypeId: number = 0;
  private toolTypeId: number = 0;
  private requestEmployeeId: number = 0;
  private employeeAssigned: IDtoJobCandidateBasic;
  private employeeOwner: IDtoJobCandidateBasic;
  private oldAssignedEmpId: number;
  private model: any = {
    onColor: 'primary',
    offColor: 'secondary',
    onText: 'Nuevo',
    offText: 'Cerrado',
    disabled: false,
    size: 'sm',
    value: true
  };
  private formIncident: FormGroup;
  private config = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
  };
  private itemsPageList: number[] = [5, 10, 15, 20, 30, 50];
  private page: number = 2;
  private itemsPage: number = 20;
  private modalRef: BsModalRef;
  private errorReceived: boolean;
  private listEvents: IDtoEvent[] = []; //  = new List<IDtoEvent>();
  private listEventsPage: IDtoEvent[] = [];
  private listTickets: IDtoTicket[] = [];
  private listEventsFilter: IDtoEvent[] = [];
  private listEmployeesAssigned: IDtoCatalog[];
  private listStatusIncident: IDtoCatalog[];

  private list: any[] = [];
  private event = {} as IDtoEvent;
  private ticket = {} as IDtoTicket;
  private showEvent: boolean;
  private tk = {} as IDtoTicket;
  private userData: IDtoJobCandidateBasic;
  private enabledSave = true;
  private rutaFile: string;
  private showDownloadFile = false;
  private isRolUsuario: boolean;
  private roles: any;
  private showRoles: any;
  employee: IDtoJobCandidateBasic;
   /**Validadores */
   private validator = ValidatorService;
   private fsaFlags = [false];
   private flag = false;
   private errorMessages: any;
  constructor(private serviceIncident: IncidentService
    , private modalService: BsModalService
    , private emailService: EmailService
    , private formBuilder: FormBuilder
    , private configuration: ConfigurationService
    , private router: Router
    , private appConfig: AppConfig
    , private storageService: StorageService
    , private securityService: SecurityService
    , private employeeService: EmployeeService
    , private route: ActivatedRoute
    , private messageService: MessageService) {
    this.showRoles = this.securityService.getUserRolesStorage();
  }

  public ngOnInit() {
    this.formIncident = this.formBuilder.group({
      fcnStatusIncident: [null],
      fcnStatusEmployeeAssigned: [null],
      txtSolution: [null],
      txtDescription: [null],
      txtComments: [null, Validators.required],
      assignedEmp: [null]
    });
    this.getEmployee();
    this.userData = this.storageService.retrieve('userData');
    this.employeeOwner = {} as IDtoJobCandidateBasic;
    this.employeeAssigned = {} as IDtoJobCandidateBasic;
    this.oldAssignedEmpId = 0;
    this.isRolUsuario = false;
    this.initializeData();
    this.roles = this.securityService.getUserRolesStorage();

    this.load();
  }
  private initializeData(): void {
    this.route.params.subscribe((params) => {
      if (params['ticketId']) {
        this.showEvent = false;
        setTimeout(() => {
          this.getTicketById(Number(params['ticketId']));
        }, 2);
      }
      if (params['eventId']) {
        setTimeout(() => {
          this.showEvent = true;
          this.getEventById(Number(params['eventId']));
        }, 2);
      }
    });
  }
  private getEmployee(): void {
    this.employeeService.getEmployee(this.showRoles.employeeId).subscribe((res) => {
      this.employee = res.data as IDtoJobCandidateBasic;
    },
      (errMessage) => {
        this.appConfig.newToast('Error', errMessage.message, 'error');
      });
  }
  private getTicketById(ticketId: number): void {
    this.serviceIncident.getTicketById(ticketId).subscribe((res) => {
      this.ticket = res;
      this.oldAssignedEmpId = this.ticket.assignedEmpId;
      this.selectTicket(this.ticket);
    },
      (errMessage) => {
        this.appConfig.newToast('Error', errMessage.message, 'error');
      });
  }
  private getEventById(eventId: number): void {
    this.serviceIncident.getEventById(eventId).subscribe((res) => {
      this.event = res;
      this.listTickets = this.event.tickets;
      this.selectTicket(this.listTickets[0]);
    },
      (errMessage) => {
        this.appConfig.newToast('Error', errMessage.message, 'error');
      });
  }
  private load() {
    let profile = this.securityService.getProfileStorage('Incident');
    if (profile == 'Usuario') {
      this.isRolUsuario = true;
      this.formIncident.controls['fcnStatusEmployeeAssigned'].disable();
      this.formIncident.controls['fcnStatusIncident'].disable();
      this.formIncident.controls['txtComments'].disable();
      this.formIncident.controls['txtSolution'].disable();
    } else {
      this.formIncident.controls['txtDescription'].disable();
    }
  }

  private mostrarElementos(item: any, data: IDtoEvent[]): void {
    this.itemsPage = item;
    const startItem = (1 - 1) * this.itemsPage;
    const endItem = 1 * this.itemsPage;
    this.listEventsPage = data.slice(startItem, endItem);
    this.page = 1;
  }

  private initializeValuesTicket(ticket) {
    {
      this.oldAssignedEmpId = ticket.assignedEmpId;
      this.selectTicket(ticket);
    }
  }

  private extendedTicket(ticket: IDtoTicket): void {
    this.event.status = ticket.status;
    this.listTickets.push(ticket);
  }

  private pageChanged(event: PageChangedEvent): void {
    const startItem = (event.page - 1) * event.itemsPerPage;
    const endItem = event.page * event.itemsPerPage;
    this.listEventsPage = this.listEventsFilter.slice(startItem, endItem);
  }
  //
  private goToIncidents(): void {
    this.router.navigate(['/incident/records']);
  }
  //
  private onSelect(item: IDtoCatalog, control: string) {
    if (item != null || item !== undefined) {
      switch (control) {
        case ('fcnStatusIncident'):
          // asigno el title y el resourceId a evento y el mismo valor al ticket

          this.ticket.status = +item.id;
          break;
        case ('fcnStatusEmployeeAssigned'):
          this.ticket.assignedEmpId = +item.id;
          break;
      }
    }
  }
  //
  private getEmployeesAssigned() {
    this.serviceIncident.getEmployeesAssigned()
      .catch((err) => this.handleError(err))
      .subscribe((data) => {

        this.listEmployeesAssigned = data.data as IDtoCatalog[];
        this.formIncident.controls['fcnStatusEmployeeAssigned'].setValue(this.ticket.assignedEmpId);
        //this.ticket.assignedEmp = this.listEmployeesAssigned.find(x => x.id == this.ticket.assignedEmpId).name;
      });
    this.formIncident.controls['fcnStatusIncident'].setValue(this.ticket.status);
  }
  //
  private updateTicket(): Observable<IResult> {
    if (this.formIncident.valid) {
      if (this.ticket.status == 4 && (this.ticket.solution == null || this.ticket.solution == undefined) ) {
        this.appConfig.newToast('Validación', 'Ingrese la solución del ticket antes de cerrarlo', 'warning');
        return;
      }
      this.ticket.eventClose = this.ticket.status == 4;
      const updateTicketObservable = this.serviceIncident.updateTicket(this.ticket);
      updateTicketObservable
        .subscribe(
          (x) => {
            const result = x;
            if (result.isCorrect) {
              this.event.status = this.ticket.status;
              // If assigned employee has changed then send email notification
              let emp = this.listEmployeesAssigned.find(x => x.id == this.ticket.assignedEmpId);
              if (this.oldAssignedEmpId !== this.ticket.assignedEmpId) {
                let messaje = `usted tienen asignado un incidente con número de folio ${this.ticket.ticketId} y asunto ${this.ticket.title}. Favor de acceder a http://rednovation.azurewebsites.net/ para su atención.`;
                this.sendMessage(emp.description, emp.id, emp.additional, messaje);
                this.oldAssignedEmpId = this.ticket.assignedEmpId;

              }
              // If ticket is closed send email to owner employee
              if (this.ticket.status === 4) {
                let messaje = `el incidente con número de folio ${this.ticket.ticketId} y asunto ${this.ticket.title}, ha sido cerrado. Para ver mas detalles de la resolución del incidente, favor de ingresar a http://rednovation.azurewebsites.net/.`;
                this.sendMessage(emp.description, this.ticket.ownerEmpId, this.ticket.ownerEmpUKey, messaje);
              }

              this.tk.status = this.ticket.status;
              this.appConfig.newToast('¡Exito!', 'Datos actualizados', 'success');
            }
          },
          (errMessage) => this.handleError = errMessage.messages);
      return updateTicketObservable;
    } else {
      this.appConfig.newToast('Validación!', 'Ingrese la información requerida', 'warning');
    }

  }
  //
  private selectTicket(entidad: IDtoTicket): void {
    //this.list = [];
    this.oldAssignedEmpId = entidad.assignedEmpId;
    this.tk = entidad;
    this.ticket = Object.assign({}, entidad);
    this.listStatusIncident = this.serviceIncident.listStatusIncident;
    /** Evaluo si habilito el botom de guardar */
    if (this.tk.status === 4 || this.tk.ownerEmpId === this.userData.id) {
      this.enabledSave = false;
    } else {
      this.enabledSave = true;
    }
    this.getEmployeesAssigned();
  }

  private getCatalogsModal(item: any, accion: string, id: number) {
    let any = this.listTickets.some(ticket => ticket.status != 4);
    if (any) {
      this.appConfig.newToast('¡Validación!', 'No es posible generar un nuevo ticket debido a tickets abiertos en este evento', 'warning');
      return;
    }
    this.serviceIncident.getCatalogs();
    const t = this.serviceIncident.listCatalogsChallenge$.subscribe((res) => {
      t.unsubscribe();
      this.openModalIncident(item, accion, res, id);
    });
  }

  private openModalIncident(item: any, acc: string, catalogs: any[], id: number) {
    const initialState = {
      list: catalogs,
      title: 'Información del ticket',
      accion: acc,
      eventId: id,
      employee: this.employee
    };

    this.modalRef = this.modalService.show(ModalIncidentComponent
      , Object.assign({ initialState }
        , { class: 'gray modal-lg' }, this.config));
    this.modalRef.content.closeBtnName = 'Close';
    this.modalRef.content.onClose.subscribe((result) => {
      if (result != null) {
        switch (acc) {
          case ('nuevo'):
            this.extendedTicket(result);
            this.appConfig.newToast('¡Exito!', 'Datos agregados', 'success');
            break;
          case ('editar'):
            break;
        }
      }
    });
  }

  private sendMessage(personalNumber: string, assignedEmpId: number, uKey: string, message: string): void {
    this.employeeService.getBusinessPhone(uKey)
      .subscribe(
        (x) => {
          let dto = {} as IDtoMessageDetail;
          dto.recipientId = x == null ? personalNumber : x.toString();
          dto.messageSent = message;
          dto.employeeId = assignedEmpId;
          dto.template = 'incidente_nuevo';
          this.messageService.sendMessage(dto)
            .subscribe(
              (x) => {
              },
              (errMessage) => {
                this.appConfig.newToast('Error', errMessage.error.exception, 'error');
              });
        },
        (errMessage) => {
          this.appConfig.newToast('Error', errMessage.message, 'error');
        });
  }
  private handleError(error: any) {
    this.errorReceived = true;
    return Observable.throw(error);
  }
}
